import api from '../../plugins/api';

const initialFeeCreditCardPayment = (payload) => {
  return api.post('/api/bank/initialFeeCreditCardPayment', payload);
};

export default initialFeeCreditCardPayment;
